import React from 'react'
import PropTypes from 'prop-types'
import ReactImageGallery from 'react-image-gallery'
// import {MemoizedLeftNav} from './LeftNav'
import LeftNav from './LeftNav'
import RightNav from './RightNav'
import MemoizedRenderItem from './RenderItem'
import Lightbox from '@components/LightBox'

const ImageGallery = (props) => {
  const {
    images,
    onClose,
    show,
  } = props

  return (
    <Lightbox
      show={show}
      onClose={onClose}
    >
      <div className={'w-full h-full flex items-center justify-center'}>
        <ReactImageGallery
          showPlayButton={false}
          showFullscreenButton={false}
          showThumbnails={false}
          infinite={false}
          items={images}
          renderItem={(item) => <MemoizedRenderItem {...item} onClose={() => { onClose() }} />}
          renderLeftNav={(onClick, disabled) => (
            <LeftNav onClick={(e) => {
              e.stopPropagation()
              onClick()
              }} disabled={disabled} />
          )}
          renderRightNav={(onClick, disabled) => (
            <RightNav onClick={(e) => {
              e.stopPropagation()
              onClick()
              }} disabled={disabled} />
          )}
        />
      </div>
    </Lightbox>
  )
}

ImageGallery.propTypes = {
  images: PropTypes.array,
  onClose: PropTypes.func,
}

export default ImageGallery
